import {object} from 'prop-types';
import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {fitExtent} from '@app/actions/map';
import {trackEvent} from '@app/analytics';
import ZoomToButton from '@components/common/ZoomToButton';

const ZoomToCollectionButton = ({collection, ...props}) => {
  const dispatch = useDispatch();

  const onZoomTo = useCallback(() => {
    if (
      collection?.extent?.spatial?.bbox?.length > 0 &&
      Boolean(collection?.extent?.spatial?.bbox[0][0])
    ) {
      trackEvent('Collection Toolbar', {
        action: 'Zoomed to collection',
        featureId: collection.id,
      });
      dispatch(fitExtent(collection.extent?.spatial?.bbox[0]));
    }
  }, [collection, dispatch]);

  return (
    <ZoomToButton
      tooltipText="Zoom to collection extent"
      onClick={() => onZoomTo(collection)}
      {...props}
    />
  );
};

ZoomToCollectionButton.propTypes = {
  collection: object.isRequired,
};

export default ZoomToCollectionButton;
